import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useHistory,
} from "react-router-dom";
import jwt_decode from "jwt-decode";
import {
  Navbar,
  Nav,
  NavDropdown,
  Button,
  Container,
} from "react-bootstrap";

import logo from "../images/ridersmiami-logo.png";
import "../css/navbar.css";

export default function NavBar() {
  const location = useLocation();
  const history = useHistory();

  const [user, setUser] = useState("Iniciar sesión");
  const [role, setRole] = useState("");
  const [expanded, setExpanded] = useState(false);


  const [theme, setTheme] = useState(
    () => localStorage.getItem("riders-theme") || "light"
  );

  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      theme
    );

    localStorage.setItem("riders-theme", theme);
  }, [theme]);

  useEffect(() => {
    try {
      const usuarioLS = JSON.parse(
        localStorage.getItem("usuario") ||
          localStorage.getItem("user")
      );

      setUser(usuarioLS || "Iniciar sesión");
    } catch {
      setUser("Iniciar sesión");
    }

    const token = localStorage.getItem("token") || "";

    try {
      if (token) {
        const decoded = jwt_decode(token);

        const usuario =
          decoded?.usuario ||
          decoded?.user ||
          decoded;

        setRole(usuario?.role || "");
      } else {
        setRole("");
      }
    } catch {
      setRole("");
    }
  }, [location]);

  const handleLogout = () => {
    [
      "token",
      "id",
      "usuario",
      "user",
      "userDisplay",
      "authToken",
      "jwt",
    ].forEach((key) => localStorage.removeItem(key));

    setRole("");
    setUser("Iniciar sesión");
    history.push("/login");
  };

  const esRoot = role === "ROOT_ROLE";
  const esAdmin =
    esRoot || role === "ADMIN_ROLE";

  const esVendedor =
    role === "VENDEDOR_ROLE";

  const esManager =
    role === "MANAGER_ROLE";

  const nombreBoton =
    typeof user === "string"
      ? user
      : [user?.nombres, user?.apellidos]
          .filter(Boolean)
          .join(" ") ||
        user?.email ||
        "Salir";

  const inicialUsuario = String(
    nombreBoton || "U"
  )
    .trim()
    .charAt(0)
    .toUpperCase();

  const financierasConsultaLink = {
    label: "Financieras",
    to: "/financieras-vigentes",
    icon: "$",
  };

  const comisionesLink = {
    label: "Comisiones",
    to: "/HomeComisiones",
    icon: "%",
  };
  
  const adminLinks = [
    {
      label: "Seguimientos",
      to: "/Home",
      icon: "⌖",
    },
    {
      label: "Altas",
      to: "/HomeAltas",
      icon: "+",
    },
    {
      label: "Informes",
      to: "/HomeImpresion",
      icon: "▥",
    },
    financierasConsultaLink,
    comisionesLink,
    {
      label: "Acerca de",
      to: "/AcercaDe",
      icon: "i",
    },
  ];

  const rootLinks = [
    adminLinks[0],
    adminLinks[1],
    adminLinks[2],
    {
      label: "Usuarios",
      to: "/usuarios-admin",
      icon: "♙",
    },
    financierasConsultaLink,
    comisionesLink,
    adminLinks[5],
  ];

  const vendedorLinks = [
    {
      label: "Seguimiento",
      to: "/Home",
      icon: "⌖",
    },
    {
      label: "Altas",
      to: "/HomeAltas",
      icon: "+",
    },
    {
      label: "Informes",
      to: "/HomeImpresion",
      icon: "▥",
    },
    financierasConsultaLink,
    {
      label: "Acerca de",
      to: "/AcercaDe",
      icon: "i",
    },
  ];

  const managerLinks = [
    {
      label: "Ventas",
      to: "/Ventas",
      icon: "⌖",
    },
    {
      label: "Venta rápida",
      to: "/ventarapida",
      icon: "+",
    },
    financierasConsultaLink,
    {
      label: "Clientes USA",
      to: "/Clientes",
      icon: "♙",
    },
    {
      label: "Clientes Cuba",
      to: "/ClientesRecepcion",
      icon: "♙",
    },
  ];

  const managerInformes = [
    {
      label: "Informe de ventas",
      to: "/informeventas",
    },
    {
      label: "Ventas anuladas",
      to: "/informeventasanuladas",
    },
    {
      label: "Informe financiero",
      to: "/informefinancieroventas",
    },
    {
      label: "Dashboard financiero",
      to: "/informedashboardfinanciero",
    },
    {
      label: "Ventas por vendedor",
      to: "/informevendedoresventas",
    },
    {
      label: "Seguimientos de clientes",
      to: "/informeseguimientosclientes",
    },
  ];

  const links = esRoot
    ? rootLinks
    : esAdmin
    ? adminLinks
    : esManager
    ? managerLinks
    : esVendedor
    ? vendedorLinks
    : [];
    
  const isActive = (to) =>
    location.pathname === to;

  const auditoriaActiva = [
    "/informeauditoria",
    "/dashboardauditoria",
  ].includes(location.pathname);

  const managerInformesActivo =
    managerInformes.some(
      (item) =>
        item.to === location.pathname
    );

  const toggleTheme = () => {
    setTheme((prev) =>
      prev === "dark" ? "light" : "dark"
    );
  };

  return (
    <div className="navbar-shell-riders">
      <Container fluid className="px-3 px-md-4">
        <Navbar
          expand="lg"
          sticky="top"
          className="navbar-riders"
          expanded={expanded}
          onToggle={(nextExpanded) =>
            setExpanded(nextExpanded)
          }
        >
          <Navbar.Brand
            as={Link}
            to="/"
            className="d-flex align-items-center"
          >
            <img
              src={logo}
              alt="Riders Miami"
              className="navbar-logo-riders me-2"
            />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="riders-nav"
            className="navbar-toggle-riders"
          />

          <Navbar.Collapse id="riders-nav">
            <Nav className="ms-auto align-items-lg-center">
              {links.map(
                ({ label, to, icon }) => (
                  <Nav.Link
                    as={Link}
                    key={to}
                    to={to}
                    onClick={() => setExpanded(false)}
                    className={`px-3 nav-link-riders ${
                      isActive(to) ? "active" : ""
                    }`}
                  >
                    <span className="nav-icon-riders">
                      {icon}
                    </span>

                    <span>{label}</span>
                  </Nav.Link>
                )
              )}

              {esManager && (
                <NavDropdown
                  id="manager-informes-nav-dropdown"
                  className={`nav-dropdown-riders ${
                    managerInformesActivo ? "active" : ""
                  }`}
                  title={
                    <span className="d-inline-flex align-items-center gap-1">
                      <span className="nav-icon-riders">
                        ▥
                      </span>

                      <span>Informes</span>
                    </span>
                  }
                >
                  {managerInformes.map(
                    ({ label, to }) => (
                      <NavDropdown.Item
                        key={to}
                        as={Link}
                        to={to}
                        onClick={() => setExpanded(false)}
                        active={
                          location.pathname === to
                        }
                      >
                        {label}
                      </NavDropdown.Item>
                    )
                  )}
                </NavDropdown>
              )}

              {/* Auditoría: solo Root y Administrador */}
              {esAdmin && (
                <NavDropdown
                  id="auditoria-nav-dropdown"
                  className={`nav-dropdown-riders ${
                    auditoriaActiva ? "active" : ""
                  }`}
                  title={
                    <span className="d-inline-flex align-items-center gap-1">
                      <span className="nav-icon-riders">
                        ◎
                      </span>

                      <span>Auditoría</span>
                    </span>
                  }
                >
                  <NavDropdown.Item
                    as={Link}
                    to="/informeauditoria"
                    onClick={() => setExpanded(false)}
                    active={
                      location.pathname ===
                      "/informeauditoria"
                    }
                  >
                    Informe de auditoría
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to="/dashboardauditoria"
                    onClick={() => setExpanded(false)}
                    active={
                      location.pathname ===
                      "/dashboardauditoria"
                    }
                  >
                    Dashboard de auditoría
                  </NavDropdown.Item>
                </NavDropdown>
              )}
            </Nav>

            <div className="d-flex align-items-center gap-2 ms-lg-3 mt-3 mt-lg-0">
              <Button
                type="button"
                size="sm"
                className="btn-theme-riders"
                onClick={toggleTheme}
                title={
                  theme === "dark"
                    ? "Cambiar a tema claro"
                    : "Cambiar a tema oscuro"
                }
              >
                <span className="theme-icon-riders">
                  {theme === "dark" ? "☀" : "☾"}
                </span>

                <span className="d-none d-md-inline">
                  {theme === "dark"
                    ? "Claro"
                    : "Oscuro"}
                </span>
              </Button>

              <Button
                size="lg"
                className="fw-bold px-4 py-2 btn-navbar-login"
                onClick={handleLogout}
              >
                <span className="user-dot-riders">
                  {inicialUsuario}
                </span>

                <span>{nombreBoton}</span>
              </Button>
            </div>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </div>
  );
}